import React from 'react'

import { useMobile } from 'hooks/ua'
import Item from './Item'

import icon1 from './images/icon1.png'
import icon2 from './images/icon2.png'
import icon3 from './images/icon3.png'
import PcArrow from './images/pcArrow.svg'
import MobileArrow from './images/mobileArrow.svg'

import styles from './style.less'

export default function Intro() {
  const isMobile = useMobile()

  return (
    <>
      <div className={isMobile ? styles.mobileWrap : styles.pcWrap}>
        <Item icon={icon1} title="大量闲置带宽需快速变现" />
        <Item icon={icon2} title="拥有自有平台" />
        <Item icon={icon3} title="有招募资源能力" />
      </div>
      {isMobile ? <MobileArrow className={styles.mobileArrow} /> : <PcArrow className={styles.pcArrow} />}
    </>
  )
}
